import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularCustomSelectorComponent } from './angular-custom-selector.component';
import { MultiSelectorModule } from './multi-selector/multi-selector-module';
import { SingleSelectorModule } from './single-selector/single-selector-module';

@NgModule({
  declarations: [AngularCustomSelectorComponent],
  imports: [
    SingleSelectorModule,
    MultiSelectorModule,
    CommonModule
  ],
  exports: [AngularCustomSelectorComponent]
})
export class AngularCustomSelectorModule { }
